// extracted by mini-css-extract-plugin
export default {"legalTextBanner":"legaltext-banner_legalTextBanner__G6exJ","legalTextContent":"legaltext-banner_legalTextContent__p6t0z"};